import * as React from 'react'

import { cn } from '@shared/ui/lib/utils'
import './textarea.css'

export interface TextareaProps extends React.ComponentPropsWithoutRef<'textarea'> {
  readonly fullWidth?: boolean
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  {
    className,
    fullWidth = true,
    ...props
  },
  ref,
) {
  return (
    <textarea
      className={cn(
        'min-h-28 resize-y rounded-md border px-3.5 py-2.5 text-sm outline-none transition-[background-color,border-color,box-shadow,color] duration-150',
        fullWidth ? 'w-full' : 'w-auto',
        className,
      )}
      data-slot="textarea"
      ref={ref}
      {...props}
    />
  )
})

export { Textarea }
